import { graphql } from "relay-runtime"

export const chPsychologicalPsychoTherapyFragment = graphql`
  fragment chPsychologicalPsychoTherapyFragment on ch_PsychotherapyPrescription {
    id
    patientId
    progressNoteId
    additionalInformation
    createdAt
    createdBy
    diagnosisCode
    fileId
    healthcareProviderId
    language
    reason
    signedAt
    signedBy
    therapyPrescription
    updatedAt
    updatedBy
    sentAt
    sentBy
    concludedAt
    concludedBy
    fileMetadata {
      documentType
      extension
      lengthInKilobytes
    }
  }
`
